export default __webpack_public_path__ + "static/media/Logo.3591865f.svg";